import AccountService from "@/services/AccountService";
export default {
  namespaced: true,
  state: {
    devices: null
  },
  mutations: {
    saveDevices (state, devices) {
      state.devices = [...devices];
    }
  },
  actions: {
    async fetchDevices ({ commit, rootState }) {
      const token = rootState.auth.token;
      const username = rootState.auth.username;
      try {
        const res = await AccountService.fetchDevices({ username }, token);
        if (res.data.status) {
          commit("saveDevices", res.data.devices);
        }
        return res;
      } catch (err) {
        throw new Error(err);
      }
    },
    async fetchDevicesByUser ({ commit, rootState }, nameList) {
      const token = rootState.auth.token;
      const owner = rootState.auth.username;
      try {
        const res = await AccountService.fetchDevicesByUser(
          { nameList, owner },
          token
        );


        if (res.data.status) {
          commit("saveDevices", res.data.devices);
        }
        return res;
      } catch (err) {
        throw new Error(err);
      }
    }
  }
};
